module.exports = __webpack_public_path__ + "img/sv21.131801b8.svg";